import { format } from "date-fns";
import { graphql, Link, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React, { useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import OnclickButton from "./OnclickButton";

const CaseStudiesCatalogue = ({ colour, featuredCaseStudy }) => {
	console.log(featuredCaseStudy);
	// Fetching case studies data using GraphQL
	const data = useStaticQuery(graphql`
		query {
			allWpCaseStudy {
				nodes {
					title
					id
					date
					slug
					caseStudyFields {
						numberOfMinRead
						description
						featuredImage {
							altText
							localFile {
								childImageSharp {
									gatsbyImageData(
										formats: [WEBP, AUTO]
										quality: 80
										transformOptions: { cropFocus: CENTER, fit: COVER }
										layout: CONSTRAINED
										placeholder: BLURRED
									)
								}
							}
						}
						authorName
						authorImage {
							altText
							localFile {
								childImageSharp {
									gatsbyImageData(
										formats: [WEBP, AUTO]
										quality: 80
										transformOptions: { cropFocus: CENTER, fit: COVER }
										layout: CONSTRAINED
										placeholder: BLURRED
									)
								}
							}
						}
					}
				}
			}
		}
	`);

	// Exclude the featured case study
	// Safely access the featured case study ID
	const featuredId = featuredCaseStudy?.[0]?.id;

	// Ensure nodes is an array
	const caseStudies =
		data.allWpCaseStudy.nodes?.filter((study) => {
			// If no featured case study, include all studies
			if (!featuredId) {
				return true;
			}
			// Exclude the featured case study
			return study.id !== featuredId;
		}) || []; // Default to an empty array if nodes is undefined

	// States for limiting case studies displayed
	const [visibleCount, setVisibleCount] = useState(6);

	// Adjust the number of case studies visible based on the screen size
	const handleViewAll = () => setVisibleCount(caseStudies.length);

	return (
		<div>
			{caseStudies && caseStudies?.length > 0 && (
				<section className="py-5 py-lg-7">
					<Container>
						<Row className="gy-4">
							{caseStudies.slice(0, visibleCount).map((study, index) => {
								const featuredImage = getImage(
									study.caseStudyFields.featuredImage?.localFile
										?.childImageSharp
								);

								const authorImage = getImage(
									study.caseStudyFields.authorImage?.localFile?.childImageSharp
								);

								const formattedDate = format(
									new Date(study.date),
									"dd MMM yyyy"
								);

								return (
									<Col
										md={6}
										lg={4}
										sm={6}
										xs={12}
										key={index}
										className="mb-4"
									>
										<Link
											className="text-decoration-none"
											to={`/case-studies/${study.slug}`}
										>
											<Card className="h-100  border-0">
												{/* Featured Image */}
												{featuredImage && (
													<div
														className="mb-4"
														style={{ borderRadius: "12px", overflow: "hidden" }}
													>
														<GatsbyImage
															image={featuredImage}
															alt={study.caseStudyFields.featuredImage?.altText}
															className="card-img-top"
															style={{ height: "250px", objectFit: "cover" }}
														/>
													</div>
												)}
												<Card.Body className="p-0">
													{/* Case Study Title */}
													<h5 style={{ color: colour }}>{study.title}</h5>
													{/* Case Study Description */}
													<p>{study.caseStudyFields.description}</p>
													{/* Author and Meta Information */}
													<div className="d-flex align-items-center gap-3 mt-3">
														{/* Author Avatar */}
														{authorImage ? (
															<GatsbyImage
																image={authorImage}
																alt={study.caseStudyFields.authorImage?.altText}
																style={{
																	width: "40px",
																	height: "40px",
																	borderRadius: "50%",
																}}
															/>
														) : (
															<div
																style={{
																	width: "40px",
																	height: "40px",
																	borderRadius: "50%",
																	backgroundColor: "#eaeaea",
																}}
															/>
														)}
														<div>
															<p
																className="outfit-bold pb-0 mb-0"
																style={{ color: colour, fontSize: "90%" }}
															>
																{study.caseStudyFields.authorName}
															</p>
															<p
																style={{ fontSize: "90%" }}
																className=" mb-0  d-flex align-items-center"
															>
																{formattedDate}{" "}
																<span
																	className="mx-2"
																	style={{
																		display: "inline-block",
																		width: "5px",
																		height: "5px",
																		borderRadius: "50%",
																		backgroundColor: "#3BA3DA",
																		margin: "0 5px",
																	}}
																></span>
																{study.caseStudyFields.numberOfMinRead} min read
															</p>
														</div>
													</div>
												</Card.Body>
											</Card>
										</Link>
									</Col>
								);
							})}
						</Row>

						{/* View All Button */}
						{visibleCount < caseStudies.length && (
							<Row className="text-center mt-4 mt-md-5">
								<Col>
									<OnclickButton
										width="w-100 w-md-auto"
										colour="#3BA3DA"
										text="View All"
										isOutline={true}
										onClick={handleViewAll}
									/>
								</Col>
							</Row>
						)}
					</Container>
				</section>
			)}
		</div>
	);
};

export default CaseStudiesCatalogue;
